import React, { useEffect, useState, useRef } from 'react';
import './App.css';
import myImage from './pic.jpg';
import IRisk from './irisk.jpeg';
import entre from './entrecorps.jpeg';
import outlier from './outlier.png';
import illcs from './illcs.png';
import nxg from './nxg.jpg';
import p1 from './photo1.JPEG';
import p2 from './photo2.jpeg';
import p3 from './photo3.jpeg';
import p4 from './photo4.jpeg';
import p5 from './photo5.jpeg';
import p6 from './photo6.jpeg';
import p7 from './photo7.jpeg';
import p8 from './photo8.jpeg';
import p9 from './photo9.jpeg';
import p10 from './photo10.jpeg';
import p11 from './photo11.jpeg';
import p12 from './photo12.jpeg';

import YouTube from 'react-youtube';
import { ReactTyped as Typed } from 'react-typed';
import { initStars } from './stars';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { color, motion } from 'framer-motion';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    initStars();

    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;

      if (scrollPosition < windowHeight) {
        setCurrentPage('home');
      } else if (scrollPosition < windowHeight * 2) {
        setCurrentPage('experience');
      } else {
        setCurrentPage('interests');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const experiences = [
    {
      title: 'Data Engineer',
      company: 'IRisk Lab',
      description:
        'Engineered a scalable data pipeline to process climate, insurance, and real estate data to train ML models for predicting insurance risk indices.',
      logo: IRisk,
    },
    {
      title: 'Consultant',
      company: 'EntreCORPS',
      description:
        'Worked closely with startups to create strategic solutions by leveraging research, data analysis, and innovation.',
      logo: entre,
    },
    {
      title: 'AI Software Developer',
      company: 'Outlier AI',
      description:
        'Implemented prompt engineering and reinforcement learning through human feedback to improve model accuracy in natural language processing tasks.',
      logo: outlier,
    },
    {
      title: 'Course Assistant',
      company: 'UIUC CS 124',
      description:
        'Provided personalized support on course content and programming language (Java, Kotlin) while facilitating a collaborative learning environment for students.',
      logo: illcs,
    },
  ];



  const projects = [
    {
        title: "Calorie Tracker & Visualization",
        description: "Tracking calories/macronutrients can be very overwhelming so this application is a user-friendly and accessible solution that helps all people track their relevant health information.",
        githubLink: "https://github.com/ribhavn25/Calorie-Tracker"
    },
    {
        title: "Found It!",
        description: "Found It! is a web app for Illinois students to search for their missing things on a platform which filters items by there location and the type of item specified. Additionally, it relies on good Samaritans to post missing items when they spot them.",
        githubLink: "https://github.com/ribhavn25/Found-It-HackIllinois-2024"
    }
];



  const travelPhotos = [p1, p2, p3, p8, p5, p6, p4, p9, p7, p10, p11, p12];

    const chunkArray = (arr, size) => {
        return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
            arr.slice(i * size, i * size + size)
        );
    };

    const photoRows = chunkArray(travelPhotos, 4);



  

  return (
    <div className="App">
      <header>
        <nav>
          <ul>
            <li>
              <a href="#home" className={currentPage === 'home' ? 'active' : ''}>
                Home
              </a>
            </li>
            <li>
              <a href="#experience" className={currentPage === 'experience' ? 'active' : ''}>
                Experience
              </a>
            </li>
            <li>
              <a href="#projects" className={currentPage === 'projects' ? 'active' : ''}>
                Projects
              </a>
            </li>
            <li>
              <a href="#interests" className={currentPage === 'interests' ? 'active' : ''}>
                Interests
              </a>
            </li>
          </ul>
        </nav>
        <div className="social-links">
          <a href="mailto:ribhav999@gmail.com" className="email-link">
            <FontAwesomeIcon icon="envelope" />
          </a>
          <a href="https://www.linkedin.com/in/ribhav-nagayach/" target="_blank" rel="noopener noreferrer" className="linkedin-link">
            <FontAwesomeIcon icon={['fab', 'linkedin']} />
          </a>
        </div>
      </header>
      <section id="home">
        <div id="stars-container"></div>
        <div className="home-content">
          <div className="left-content">
            <div className="intro-text">
              <h2>Hi, I'm Ribhav!</h2>
              <img src={myImage} alt="myImage" className="hero-img" />
              <p>
                I enjoy&nbsp;
                <span className="gradient-typed-text">
                  <Typed
                    strings={[
                      'building projects',
                      'video editing',
                      'statistics',
                      'working out',
                      'learning new things',
                    ]}
                    typeSpeed={70}
                    backSpeed={70}
                    backDelay={1500}
                    loop
                  />
                </span>
              </p>
            </div>
          </div>
          <div className="right-content">
            <p>
              I am a student at the University of Illinois at Urbana-Champaign majoring in Computer Science & Statistics and minoring in Data
              Science. I love exploring unique ways to solve complex challenges through technology, and I am interested in software and data engineering opportunities!
            </p>
          </div>
        </div>
      </section>
      <section id="experience">
        <h2>Experience</h2>
        <div className="timeline">
          {experiences.map((job, index) => (
            <motion.div
              key={index}
              className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              style={{ background: "black" }}
            >
              <div className="timeline-content">
                <h3>{job.title}</h3>
                <h4>{job.company}</h4>
                <p>{job.description}</p>
              </div>
              <div className={`timeline-logo ${index % 2 === 0 ? 'left' : 'right'}`}>
                <img src={job.logo} alt={`${job.company} logo`} className="company-logo" />
              </div>
              
            </motion.div>
          ))}
        </div>
      </section>
      <section id="projects">
        <h2>Projects</h2>
        <div className="projects-container">
            {projects.map((project, index) => (
                <motion.div
                    className="project-box"
                    key={index}
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.3 }}
                    transition={{ duration: 0.5, delay: index * 0.2 }}
                >
                    <h3>{project.title}</h3>
                    <p>{project.description}</p>
                    <a href={project.githubLink} target="_blank" rel="noopener noreferrer">
                        GitHub Repository
                    </a>
                </motion.div>
            ))}
        </div>
      </section>
      <section id="interests">
          <h3>My Interests</h3>
          <div className="interests-container">
              <motion.div
                  className="youtube-channel"
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: false, amount: 0.3 }}
                  transition={{ duration: 0.8, delay: 0.2 }}
              >
                  <h4>Video Editing</h4>
                  <div className="youtube-content">
                      <a href="https://www.youtube.com/@NXGEDITS" target="_blank" rel="noopener noreferrer" className="youtube-link">
                          <img src={nxg} alt="YouTube Logo" className="youtube-logo" />
                      </a>
                      <div className="youtube-videos">
                          <YouTube videoId="vjw8uS8RK4I" opts={{ height: '200', width: '350' }} className="video" />
                          <YouTube videoId="1Uw3_6mNRs4" opts={{ height: '200', width: '350' }} className="video" />
                          <YouTube videoId="NiB-TXV6JvE" opts={{ height: '200', width: '350' }} className="video" />
                      </div>
                  </div>
                  <p>
                      I love to edit NBA/NFL mixes. Check them out on my youtube channel, or watch some of my work right here!
                  </p>
              </motion.div>
              <div className="travel-montage">
                  <h4>Travel Adventures</h4>
                  <p>
                      I enjoy taking photos of all the amazing places I have visited around the world with my family. Here are some of my
                      favorites!
                  </p>

                  <div className="photo-grid">
                      {photoRows.map((row, index) => (
                          <motion.div
                              key={index}
                              className="photo-row"
                              initial={{ opacity: 0, y: 50 }}
                              whileInView={{ opacity: 1, y: 0 }}
                              viewport={{ once: false, amount: 0.2 }}
                              transition={{ duration: 0.8, delay: 0.2, ease: 'easeInOut' }}
                          >
                              {row.map((photo, photoIndex) => (
                                  <img key={photoIndex} src={photo} alt={`Travel Photo ${index * 4 + photoIndex + 1}`} />
                              ))}
                          </motion.div>
                      ))}
                  </div>
              </div>
          </div>
      </section>
    </div>
  );
}

export default App;
